import { render, staticRenderFns } from "./collaborator.vue?vue&type=template&id=bad4560c&scoped=true"
import script from "./collaborator.vue?vue&type=script&lang=js"
export * from "./collaborator.vue?vue&type=script&lang=js"
import style0 from "./collaborator.vue?vue&type=style&index=0&id=bad4560c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4560c",
  null
  
)

export default component.exports